import { render, staticRenderFns } from "./WidgetReview.vue?vue&type=template&id=25da5583"
import script from "./WidgetReview.vue?vue&type=script&lang=js"
export * from "./WidgetReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports